import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from '../App';
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';
import { ThemeOptions } from '@mui/material/styles';
const theme = createTheme( {
  palette: {
    mode: 'light',
    primary: {
      main: '#255079',
    },
    secondary: {
      main: '#f50057',
    },
    background: {
      paper: '#ffffff',
      default: '#fcfcfc',
    },
  },
});
const AppRouter = () => {
  return (
    <BrowserRouter>
      <div>
        <ThemeProvider theme={theme}>
        <div style={{marginTop: 0 }} className="main-content">
          <Routes>
            <Route element={<App />} path="/"  />
            <Route element={<App />} path="/handle_duplicates"  />
          </Routes>
        </div>
        </ThemeProvider>
      </div>
    </BrowserRouter>
  );
};

export default AppRouter;
